/**
 * Purpose: Helpers for society contact_numbers display and tel: links.
 * Inputs: contact list from API [{ label, phone }].
 * Outputs: normalized tel href and sanitized list for forms.
 */

export function phoneTelHref(phone) {
  const raw = (phone || '').trim();
  if (!raw) return '';
  const normalized = raw.replace(/[^\d+]/g, '');
  return normalized || raw;
}

export function normalizeContactNumbersForApi(rows) {
  if (!Array.isArray(rows)) return [];
  return rows
    .map((row) => ({
      label: (row?.label || '').trim(),
      phone: (row?.phone || '').trim(),
    }))
    .filter((row) => row.label && row.phone);
}

export function contactNumbersFromSociety(society) {
  const list = society?.contact_numbers;
  if (!Array.isArray(list)) return [];
  return list.filter((item) => item?.label && item?.phone);
}
